require('../../modules/es6.reflect.own-keys');
module.exports = require('../../modules/_core').Reflect.ownKeys;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/reflect/own-keys.js
// module id = eWjm
// module chunks = 63